import React, {Component} from "react";
import './components/main-page.css'
import MainPageComponent from "./components/pages/main-page/MainPageComponent";
import {Route, Switch} from "react-router-dom";
import TeamPage from "./components/pages/TeamPage";
import FeaturesPage from "./components/pages/FeaturesPage";
import BlogPage from "./components/pages/BlogPage";
import ContactPage from "./components/pages/ContactPage";
import ApartmentViewContainer from "./components/vew-pages/ApartmentViewContainer";
import LoginForm from "./components/login-registration-form/LoginForm";
import ProfileViewContainer from "./components/vew-pages/profile/ProfileViewContainer";
import RegistrationForm from "./components/login-registration-form/RegistrationForm";
import ApartmentSearchPage from "./components/vew-pages/ApartmentsSearchPage";

class App extends Component {
    render() {
        return (
            <div className="app-wrapper">
                <Switch>
                    <Route exact path='/' render={() => <MainPageComponent/>}></Route>
                    <Route exact path='/team' render={() => <TeamPage/>}></Route>
                    <Route exact path='/about' render={() => <FeaturesPage/>}></Route>
                    <Route exact path='/news' render={() => <BlogPage/>}></Route>
                    <Route path='/view/apartment/:apartment_uuid?' render={() => <ApartmentViewContainer/>}></Route>
                    <Route path='/search/apartments' render={() => <ApartmentSearchPage/>}></Route>
                    <Route exact path='/contacts' render={() => <ContactPage/>}></Route>
                    <Route exact path='/login' render={() => <LoginForm/>}/>
                    <Route exact path='/registration' render={() => <RegistrationForm/>}/>
                    <Route exact path='/profile' render={() => <ProfileViewContainer/>}/>
                </Switch>
            </div>
        );
    }
}

export default App;
